import { Heading, Img, Text } from "../../components";
import EventDetails from "../../components/EventDetails";
import React from "react";

export default function EventsSection() {
  return (
    <>
      {/* events section */}
      <div className="flex flex-col items-center">
        <div className="container-sm flex flex-col gap-2 lg:px-5 md:px-5">
          <div className="flex items-center justify-between gap-5">
            <Heading
              as="h1"
              className="sm:text-[18px] font-bold tracking-[0.15px] lg:text-[13px]"
            >
              Events
            </Heading>
            <div className="flex items-center gap-2 rounded-lg border border-solid border-deep_orange-100 p-1">
              <a href="/eventslist">
                <Text
                  as="p"
                  className="text-[14px] font-normal !text-deep_orange-500"
                >
                  View all
                </Text>
              </a>
              <Img
                src="images/img_arrow_right.svg"
                alt="Arrowright"
                className="h-[6px]"
              />
            </div>
          </div>
          <div className="mr-[920px] flex gap-2.5 md:mr-0 md:flex-col sm:flex-row sm:overflow-x-auto">
            <EventDetails className="w-[50%] rounded-[14px] border" />
            <EventDetails className="w-[48%] rounded-[18px] border-[0.5px]" />
          </div>
        </div>
      </div>
    </>
  );
}
